import React, { useRef, useState, useEffect } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  ScrollView,
  FlatList,
} from "react-native";
import { AntDesign, Entypo } from "@expo/vector-icons";
import { FontAwesome } from "@expo/vector-icons";
import { Octicons } from "@expo/vector-icons";
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";
import ManageAdmin from "./manageAdmin";
import { apiservice } from "../service/api";

const { width, height } = Dimensions.get("window");
const editUser = ({ state, createUniversity, setState }) => {
  console.log(state);
  const [page, setpage] = useState(0);

  const placeholder1 = {
    label: "SuperAdmin",
    value: null,
    color: "#3D6B99",
  };
  const [items1, setItems1] = useState([
    { label: "SuperAdmin", value: "SUPERADMIN" },
    { label: "Admin", value: "ADMIN" },
  ]);
  const placeholder2 = {
    label: "มหาจุฬาลงกรณ์รายวิทยาลัย",
    value: null,
    color: "#3D6B99",
  };
  const [items2, setItems2] = useState([
    { label: "มหาจุฬาลงกรณ์รายวิทยาลัย", value: "" },
    { label: "เทคโนโลยีราชมงคลกรุงเทพ", value: "" },
  ]);

  async function getallUniversity() {
    const res = await apiservice({
      path: "/university/all",
      method: "get",
    });
    if (res.status == 200) {
      setItems2(
        res.data.result.map((itemss) => ({
          ...itemss,
          label: itemss.name,
          value: itemss.id.toString(),
        }))
      );
    }
  }

  useEffect(() => {
    getallUniversity();
  }, []);

  if (items2.length == 0) {
    return <View />;
  }

  return (
    <View style={styles.container}>
      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              width: width * 0.591,
              fontSize: 18,
              fontFamily: "Prompt-Regular",
              color: "#202020",
            }}
          >
            แก้ไขผู้ดูแล
          </Text>

          <View
            style={{
              borderWidth: 0.5,
              borderColor: "#002377",
              width: width * 0.591,
              margin: 30,
            }}
          ></View>

          <View style={{ width: width * 0.591, height: height * 0.546 }}>
            <View style={styles.Boxarea}>
              <Text style={styles.Text20}>ชื่อผู้ดูแล</Text>
              <TextInput
                style={styles.TextInput}
                onChangeText={(text) =>
                  setState((val) => ({ ...val, fullname: text }))
                }
                value={state.fullname}
              />
            </View>
            <View style={styles.Boxarea}>
              <Text style={styles.Text20}>ระดับ</Text>

              <RNPickerSelect
                placeholder={placeholder1}
                style={{
                  inputWeb: {
                    width: width * 0.182,
                    height: height * 0.037,
                    borderWidth: 0.5,
                    borderColor: "#00237740",
                    borderRadius: 5,
                    paddingLeft: 10,
                    fontSize: 18,
                    fontFamily: "Prompt-Regular",
                  },
                }}
                onValueChange={(value) => {
                  setState((val) => ({ ...val, Type: value }));
                }}
                value={state.Type}
                items={items1}
              />
            </View>
            <View style={styles.Boxarea}>
              {/* <Text style={styles.Text20}>มหาวิทยาลัย</Text> */}
              <Text style={styles.Text20}>องค์กร</Text>
              <RNPickerSelect
                placeholder={placeholder2}
                style={{
                  inputWeb: {
                    width: width * 0.182,
                    height: height * 0.037,
                    borderWidth: 0.5,
                    borderColor: "#00237740",
                    borderRadius: 5,
                    paddingLeft: 10,
                    fontSize: 18,
                    fontFamily: "Prompt-Regular",
                  },
                }}
                onValueChange={(value) => {
                  setState((val) => ({ ...val, university_id: value }));
                }}
                value={state.university_id}
                items={items2}
              />
            </View>
            <View style={styles.Boxarea}>
              <Text style={styles.Text20}>ชื่อผู้ใช้งาน(username)</Text>
              <TextInput
                style={styles.TextInput}
                onChangeText={(text) =>
                  setState((val) => ({ ...val, username: text }))
                }
                value={state.username}
              />
            </View>
            <View style={styles.Boxarea}>
              <Text style={styles.Text20}>รหัสผ่าน</Text>
              <TextInput
                onChangeText={(text) =>
                  setState((val) => ({ ...val, password: text }))
                }
                secureTextEntry
                style={styles.TextInput}
                placeholder={"***********"}
              />
            </View>
            <View style={styles.Boxarea}>
              <Text style={styles.Text20}>E-mail</Text>
              <TextInput
                style={styles.TextInput}
                onChangeText={(text) =>
                  setState((val) => ({ ...val, email: text }))
                }
                value={state.email}
              />
            </View>
            <View style={styles.Boxarea}>
              <Text style={styles.Text20}>โทรศัพท์</Text>
              <TextInput
                style={styles.TextInput}
                onChangeText={(text) =>
                  setState((val) => ({
                    ...val,
                    tel_number: text.replace(/[^0-9]/g, ""),
                  }))
                }
                value={state.tel_number}
              />
            </View>

            <View style={styles.Boxareabutton}>
              <TouchableOpacity
                onPress={createUniversity}
                style={{
                  width: 100,
                  height: 40,
                  borderRadius: 5,
                  backgroundColor: "#69D443",
                  marginRight: 20,
                }}
              >
                <Text style={styles.TextButton}>ยืนยัน</Text>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => setpage(1)}
                style={{
                  width: 100,
                  height: 40,
                  borderRadius: 5,
                  backgroundColor: "#D44343",
                }}
              >
                <Text style={styles.TextButton}>ยกเลิก</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      )}
      {page == 1 && <ManageAdmin />}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Boxarea: {
    width: width * 0.297,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  Boxareabutton: {
    width: width * 0.297,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    marginTop: 30,
  },
  Text20: { fontSize: 20, fontFamily: "Prompt-Regular" },
  TextInput: {
    width: width * 0.182,
    height: height * 0.037,
    borderWidth: 0.5,
    borderColor: "#00237740",
    borderRadius: 5,
    paddingLeft: 10,
    fontSize: 18,
    fontFamily: "Prompt-Regular",
  },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});

export default editUser;
